// helper functions specific to Analytics Page
import * as moment from 'moment';
import { DAYS_TO_MESSAGE } from './constants';

// add a status field to a message
export const addStatusesToMessage = message => {
  if (message.cancelled) {
    message.status = 'Cancelled';
  } else if (!message.cancelled && message.sendTime < moment().unix()) {
    message.status = 'Sent';
  } else if (!message.cancelled && message.sendTime > moment().unix()) {
    message.status = 'Scheduled';
  }
  return message;
};

export const sortMessages = (messages, hideScheduled) => {
  return hideScheduled
    ? messages.filter(_ => _.sendTime < moment().unix())
    : messages;
};

export const formatPhoneNumber = phoneNumber => {
  // Return null if the input is null, undefined, or not a string/number
  if (
    !phoneNumber ||
    (typeof phoneNumber !== 'string' && typeof phoneNumber !== 'number')
  ) {
    return null;
  }

  // Convert the input to a string (in case it's a number)
  const phoneString = phoneNumber.toString();

  // Remove all non-digit characters
  const phone = phoneString.replace(/\D/g, '');

  // Return null if the cleaned phone number is not exactly 10 digits
  if (phone.length !== 10) {
    return null;
  }

  // Format the phone number
  return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const capitalizeFirstLetter = word => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

const returnBounceType = bounceEvent => {
  const { bounceType } = bounceEvent;
  if (!bounceType) return capitalizeFirstLetter(bounceEvent.eventName);
  if (bounceType === 'bounce') return 'Permanent Bounce';
  return 'Temporary Bounce';
};

export const convertToCSVFormat = data => {
  const keys = [
    'fullName',
    'm1_id',
    'memberId',
    'email',
    'phoneNumber',
    'eventName',
    'time',
    'errorCode',
    'errorMessage',
  ];

  const csvData = [
    [
      'Full Name',
      'M1 ID',
      'Member ID',
      'Email',
      'Phone',
      'Event',
      'Date/Time',
      'Code',
      'Reason',
    ],
  ];

  data.forEach(row => {
    const result = [];

    keys.forEach(key => {
      if (key === 'eventName' && row[key] === 'bounce') {
        result.push(returnBounceType(row));
      } else {
        result.push(row[key]); //Escaping characters not necessary for CSV because react-csv does it auto-magically.
      }
    });

    csvData.push(result);
  });

  return csvData;
};

export const formatLargeNumber = num => {
  if (num < 1_000_000) {
    return num.toString(); // under a million (7 digits), just return as-is
  }

  const suffixes = [
    { value: 1_000_000_000, suffix: 'B' },
    { value: 1_000_000, suffix: 'M' },
  ];

  for (const { value, suffix } of suffixes) {
    if (num >= value) {
      const formatted = (num / value).toFixed(3);
      return `${parseFloat(formatted)}${suffix}`;
    }
  }
};

export const generateRatio = (numerator, denominator) => {
  if (isNaN(numerator) || isNaN(denominator) || !numerator || !denominator)
    return '0%';

  return `${((numerator / denominator) * 100).toFixed(1)}%`;
};

export const getAverage = (A, B) => {
  return ((A + B) / 2).toFixed(1);
};

export const generateAverage = (A, B) => {
  // if inputs are strings, then those numbers are percentages
  if (typeof A === 'string') {
    // convert string to number and then add percentage sign at the end
    return getAverage(parseFloat(A) || 0, parseFloat(B) || 0) + '%';
  }

  // check if A and B exists and if they are numbers
  // if not then return 0
  if (isNaN(A) || isNaN(B) || !A || !B) return '0';

  return getAverage(A, B);
};

export const getSelectedTimeRangeMessage = (selectedMessageId, timeRange) => {
  if (selectedMessageId) {
    return '1 message selected';
  } else if (timeRange > 0) {
    return `last ${DAYS_TO_MESSAGE[timeRange]}`;
  } else {
    return 'all messages';
  }
};
